import React from "react"
import { Helmet } from "react-helmet"

const CSP_CONTENT = [
  "connect-src 'self' https://qmapi.qmint.com http://localhost:5266 https://qmintstoremedia.blob.core.windows.net https://cdn.jsdelivr.net https://www.google.com https://api.ipify.org https://analytics.google.com https://www.google-analytics.com/g/collect https://www.google-analytics.com https://www.googletagmanager.com https://www.googletagmanager.com/gtm.js https://www.gstatic.com https://maps.googleapis.com https://ingesteer.services-prod.nsvcs.net https://stats.g.doubleclick.net https://ipapi.co https://api.rrweb.com https://ad.doubleclick.net wss://api.rrweb.com",
].join("; ")

function CspMeta() {
  return (
    <Helmet>
      <meta httpEquiv="Content-Security-Policy" content={CSP_CONTENT} />
    </Helmet>
  )
}

export default React.memo(CspMeta)
